import HTTP from '../http-common'

export default {
    holePermission() {
        return HTTP.get('/kpi/permission')
            .then(response => response.data);
    }
}